import { Location } from '../../types/location';

export const SET_LOCATIONS = 'SET_LOCATIONS';

export class SetLocations {
  readonly type = SET_LOCATIONS;
  readonly payload: Location[];

  constructor(types: Location[]) {
    this.payload = types;
  }
}

export type Action = SetLocations;
